import React, { useEffect, useMemo } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { number } from "../../../../config";
import { getMultiDimensionDisplayValueForElement } from "../../utils/multiDimensionDisplayValue";
import "./InputRenderer.scss";

/** When chip name is stored as "parent | dimension label", show only the part after "|" on the form. */
const extractDimensionLabel = (name) => {
  try {
    if (name == null || name === "") return name ?? "";
    const nameAsString = String(name);
    const matchedPipeSeparators = nameAsString.match(/\|/g);
    const pipeSeparatorCount = matchedPipeSeparators ? matchedPipeSeparators.length : 0;
    if (pipeSeparatorCount === 0) return nameAsString.trim();
    if (pipeSeparatorCount === 1) return nameAsString.split("|")[1].trim();
    const firstSeparatorIndex = nameAsString.indexOf("|");
    return nameAsString.slice(firstSeparatorIndex + number.ONE).trim();
  } catch {
    if (name == null || name === "") return "";
    return String(name).trim();
  }
};

/**
 * Read-only field: shows the matrix cell for this dimension from the parent
 * multi-dimension chip’s currently selected option.
 * @author: Sejal
 */
const MultiDimensionDisplayRenderer = ({ element, formData, formResponses = {}, isGridElement = false, value, onChange }) => {
  const displayValue = useMemo(
    () => getMultiDimensionDisplayValueForElement(formData, formResponses, element),
    [formData, formResponses, element?.id, element?.properties?.parentWorkflowVariableId, element?.properties?.multiDimensionRowId]
  );

  const showChipName = element?.properties?.showChipName ?? true;

  useEffect(() => {
    if (onChange) {
      onChange(displayValue);
    }
  }, [displayValue]);

  return (
    <div className={`input-renderer ${isGridElement ? "mb-0" : "mb-3"}`}>
      {showChipName && <label className='form-label'>{extractDimensionLabel(element?.name)}</label>}
      <Input className='w-100 disabled' role='textbox' aria-readonly='true' aria-multiline='true' value={displayValue} readOnly={true} />
    </div>
  );
};

export default MultiDimensionDisplayRenderer;
